import React, { useContext, useState, useEffect, useCallback } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DeleteChallan, getWareHouseStoreChallan } from "../../services/ChallanApi/Challan";
import { getStoreWarehouseInfo } from "../../services/warehouse/StoreWarehouse";
import { formatDate, localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import SchedularModal from "../SchedularModal";
import StatusFilterModal from "../StatusFilterModal";
import ChallanStatusFilterModal from "./ChallanStatusFilterModal";
import WarehouseStatusFilterModal from "../Warehouse/WarehouseStatusFilterModal";
import ButtonLink from "../../ButtonLink";
import useChallanList from "../StoreContext/useChallanList";
import { getBrandStore } from "../../services/StoreUsers/PostStoreUsers";
import ChallanDeleteModal from "./ChallanDeleteModal";

const AdminChallanList = () => {
  const navigate = useNavigate();

  const { userProfileRole, brandProfileData } = getUserData();

  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  let enabledAmountRoundOffAdmin = brandProfileData.enabledAmountRoundOff ? 0 : 2;

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 30); // Subtract 30 days from the current date
  
  const [schedularDate, setSchedularDate] = useState({});
  const [selectedStatus, setSelectedStatus] = useState("ALL");
  const [challanStatusInSelection, setChallanStatusInSelection] = useState('ALL');
  const [sortingData, setSortingData] = useState(false);

  const [storeNameData, setStoreNameData] = useState("");
  const [brandStoreData, setBrandStoreData] = useState([]);
  const [selectedStore, setSelectedStore] = useState("");

  const [challanData, setChallanData] = useState([]);
  const [warehouseList, setWarehouseList] = useState([]);
  const [challanSchedularModalVisible, setChallanSchedularModalVisible] =
    useState(false);
  const [challanStatusFilterModalVisible, setChallanStatusFilterModalVisible] =
    useState(false);

  const [
    challanStatusSelectionModalVisible,
    setChallanStatusSelectionModalVisible,
  ] = useState(false);

  const [deleteChallanModal, setDeleteChallanModal] = useState(false)
  const [selectedChallanId, setSelectedChallanId] = useState("")

  // const [challanStatusInSelection, setChallanStatusInSelection] = useState("ALL");
  // const [schedularDate, setSchedularDate] = useState({});
  // const [selectedStatus, setSelectedStatus] = useState("ALL");
  const [upDateSelectedStatus, setUpDateSelectedStatus] = useState([]);
  const [loading, setLoading] = useState(true);

  // const [sortingData, setSortingData] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermView, setSearchTermView] = useState(false);

  const handleSortData = () => {
    setSortingData(!sortingData);
  };

  const handleChallanStatusSelectionModal = () => {
    setChallanStatusSelectionModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  const initializeVariable = () => {
    setChallanData([]);
  };

  const handleCalendarModal = () => {
    setChallanSchedularModalVisible(true);
  };

  const handleFilterModal = () => {
    setChallanStatusFilterModalVisible(true);
  };

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setSchedularDate(newSchedular);
  };

  const receiveDataFromStatusFilterModal = (selectedStatus) => {
    setSelectedStatus(selectedStatus);
  };

  const receiveDataFromStatusSelectionFilterModal = (selectedStatus) => {
    setChallanStatusInSelection(selectedStatus);
  };

  const fetchChallanList = (data) => {
    getWareHouseStoreChallan(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          setChallanData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const data = {
    challanTypeStatusIn: ["SENT_TO_WARE_HOUSE", "SENT_TO_STORE"],
    wareHouseStoreIdIn: warehouseList.map((item) => item.id),
    startDate: localeDateStartDate(new Date(new Date(initialStartDate))),
    endDate: localeDateEndDate(new Date(new Date())),
    // sortBy: sortingData ? "asc" : "desc",
    limit: 1000000,
    offset: 0,
    challanStatusIn: ["RECEIVED", "REQUESTED"],
  };

  const [requestData, setRequestData] = useState(data);

  useEffect(() => {
    initializeVariable();
    if (selectedStatus !== "ALL") {
      requestData.wareHouseStoreIdIn = selectedStatus;
    } else {
      requestData.wareHouseStoreIdIn = warehouseList.map((item) => item.id);
    }
    if (challanStatusInSelection !== "ALL") {
      requestData.challanStatusIn = challanStatusInSelection;
    } else {
      requestData.challanStatusIn = ["RECEIVED", "REQUESTED"];
    }
    requestData.startDate = localeDateStartDate(new Date(schedularDate?.startDate)) || localeDateStartDate(new Date(new Date(initialStartDate)));
    requestData.endDate = localeDateEndDate(new Date(schedularDate?.endDate)) || localeDateEndDate(new Date(new Date()));
    requestData.sortBy = sortingData ? "asc" : "desc";
    if (requestData.wareHouseStoreIdIn.length > 0) {
      fetchChallanList(requestData);
    }
  }, [
    schedularDate,
    selectedStatus,
    requestData,
    sortingData,
    challanStatusInSelection,
  ]);

  const fetchChallanData = (storeId) => {
    getStoreWarehouseInfo(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const warehouseData = Res.map((item) => ({
            id: item.id,
            name: item.wareHouse.name,
          }));
          setWarehouseList(warehouseData);

          requestData.wareHouseStoreIdIn = warehouseData.map((item) => item.id);
          requestData.sortBy = sortingData ? "asc" : "desc";

          setChallanData([])
          if (warehouseData.length > 0) {
            fetchChallanList(requestData);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    setUpDateSelectedStatus([]);
    setSortingData(false);
  }
  
    const fetchData = async () => {
      try {
        const response = await getBrandStore(brandId);
        if (!response.data.error) {
          const Res = response.data;
          setBrandStoreData(Res);
          const storeIds = Res.map((item) => item.id);
          const storeNames = Res.map((item) => item.storeName);
          setSelectedStore(selectedStore || storeIds[0]);
          fetchChallanData(storeIds[0]);
          setStoreNameData(storeNames[0]);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

  useEffect(() => {
    
    fetchData();
  }, []);

  useEffect(() => {
    const filteredData = challanData.filter((item) => {
      const fullName = item.challanNumber?.toLowerCase();
      return fullName?.includes(searchTerm.toLowerCase());
    });
    setChallanData(filteredData)
  }, [searchTerm]);

  useEffect(() => {
    if (selectedStore) {
      fetchChallanData(selectedStore);
    }
  }, [selectedStore]);

  const sendDataToChallanListData = ({info}) => {
     if(info) {
       fetchChallanData(selectedStore)
     }
  }

  const renderPaymentModeButtons = () => {
    return brandStoreData?.map((item) => (
      <div
        key={item.id}
        style={{
          backgroundColor: item.id === selectedStore ? "green" : "#3EB3E1",
        }}
        className="px-3 py-2 border-round-md cursor-pointer"
        onClick={() => {
          setSelectedStore(item.id);
          fetchChallanData(item.id);

          setStoreNameData(item?.storeName);
          setSearchTerm(""); 
        }}
      >
        <p className="text-white text-xl font-bold uppercase">
          {item?.storeName.replace(/_/g, " ")}
        </p>
      </div>
    ));
  };

  const OrderStatusColors = {
    BOOKED: "#3EB3E1",
    INPROCESS: "#866CCE",
    PROCESSED: "#F5C43A",
    DELIVERED: "#09B4AA",
    DONE: "#55BD5A",
    CANCEL: "#FF6767",
    UNPROCESSED: "#5D53D8",
    OUT_FOR_DELIVERY: "#6EA4F5",
    DELAY_STATUS: "E89534",
    IN_WAREHOUSE: "#a906c2",
    DEFAULT: "#000",
  };

  const rowRenderer = () => {
    return challanData?.map((item, index) => {
      const OrderStatusColors = {
        SENT_TO_STORE: "#f76aa0",
        SENT_TO_WARE_HOUSE: "#F4C430",
        DEFAULT: "#F5C43A",
      };

      const orderStatusColor =
        OrderStatusColors[item.challanTypeStatus] || OrderStatusColors.DEFAULT;
      const formattedDeliveryDate = formatDate(item.createdDate);
      const challanTypeStatus =
        item.challanTypeStatus === "SENT_TO_WARE_HOUSE"
          ? "Sent To WH"
          : "Received From WH";
      return (
        <div className="flex flex-row">
          <Accordion className="order-accordion">
            <AccordionTab
              key={index}
              style={{
                "--backgroundColor-AccordionTab": orderStatusColor,
                fontSize: 10,
              }}
              header={`${index + 1}`}
            >
            </AccordionTab>
          </Accordion>
          <Accordion className="order-flex-accordion">
          <AccordionTab
            key={index}
            style={{
              "--backgroundColor-AccordionTab": orderStatusColor,
            }}
            header={`${formattedDeliveryDate}  ${challanTypeStatus}`}
          >
            <div className="flex-row">
              <div
                className="flex-row flex-1 cursor-pointer"
              >
                <div className="col-3">
                  <p className="text-base font-semiBold capitalize">
                    Challan Number:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {item.challanNumber}
                  </p>
                </div>
                <div className="col-3">
                  <p className="text-base font-semiBold capitalize">Store:</p>
                  <p className="text-lg font-bold capitalize">
                    {item.wareHouseStore.store.storeName.replace(/_/g, " ")}
                  </p>
                </div>
                <div className="col-3">
                  <p className="text-base font-semiBold capitalize">
                    WareHouse:
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {item.wareHouseStore.wareHouse.name.replace(/_/g, " ")}
                  </p>
                </div>

                {item.status !== "REQUESTED" && (
                  <div className="col-3 flex">
                    <div className="flex-1">
                      <p className="text-base font-semiBold capitalize">
                        Total Garment:
                      </p>
                      <p className="text-lg font-bold capitalize">
                        {item.totalGarment}
                      </p>
                    </div>
                  </div>
                )}
              </div>
                {item.status === "REQUESTED" && <div
                className="flex justify-content-center align-items-center cursor-pointer"
                onClick={() => {
                  setDeleteChallanModal(true);
                  setSelectedChallanId(item.id);
                }
                }
              >
                  <img
                    src={
                      "images/delete.png"
                    }
                    style={{
                      width: 30,
                      height: 30,
                      
                    }}
                  />
              </div>}
            </div>
          </AccordionTab>
        </Accordion>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold">Challan</p>
            </div>
          </div>
          {/* sortingData */}
          <div
            onClick={() => handleSortData()}
            className="mx-2 cursor-pointer flex align-items-center"
          >
            {!sortingData ? (
              <i
                className="pi  pi-sort-amount-up-alt"
                style={{ fontSize: "25px", marginRight: 30, color: "#fff" }}
              ></i>
            ) : (
              <i
                className="pi  pi-sort-amount-down"
                style={{ fontSize: "25px", marginRight: 30, color: "#fff" }}
              ></i>
            )}
          </div>

          <div
            onClick={() => setSearchTermView(!searchTermView)}
            className="mx-2 cursor-pointer flex align-items-center"
          >
            <i
              className="pi pi-search"
              style={{ fontSize: "25px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>

          <div
            className="mx-2 cursor-pointer flex align-items-center"
            onClick={() => handleCalendarModal(true)}
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 30, marginRight: 30 }}
            />
          </div>
          <div
            className="mx-2 cursor-pointer flex align-items-center"
            onClick={() => handleFilterModal(true)}
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: 30, marginRight: 30 }}
            />
          </div>
          <div
            className="mx-2 cursor-pointer flex align-items-center"
            onClick={() => handleChallanStatusSelectionModal(true)}
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: 30, marginRight: 30 }}
            />
          </div>
        </div>
      </div>

      <div
        className="flex gap-3 my-3 mx-3 pb-1 new-scroll-bar"
        style={{
          overflowX: "auto",
          whiteSpace: "nowrap",
        }}
      >
        <div className="ml-2 flex justify-content-between  align-items-center">
          <div>
            <p className="text-xl font-semibold">Select Store : </p>
          </div>
        </div>

        {renderPaymentModeButtons()}
      </div>

      {searchTermView && (
        <div className="mt-2 mx-4 flex">
          <div className=" flex flex-1">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder="Search Challan No."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
                keyboardType="numeric"
                maxLength={25}
              />
            </IconField>
          </div>
          {searchTerm.length > 0 && (
            <div
              className="mx-3 cursor-pointer"
              onClick={() => setSearchTerm("")}
            >
              <p className="text-3xl font-Bold" style={{ color: "red" }}>
                X
              </p>
            </div>
          )}
        </div>
      )}
      <div className="mx-4 my-4">
        {loading ? (
          <div className="flex-1 flex flex-column justify-content-center align-items-center">
            <ProgressSpinner />

            <p className="text-3xl font-Bold">Challan List is Loading...</p>
          </div>
        ) : challanData.length === 0 ? (
          <div className="flex-1 flex flex-column justify-content-center align-items-center">
            <p className="text-3xl font-Bold">No Challan Found</p>
          </div>
        ) : (
          rowRenderer()
        )}
      </div>
      <SchedularModal
        setSchedularModalVisible={setChallanSchedularModalVisible}
        schedularModalVisible={challanSchedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
        typeOfOrder={""}
      />
      <ChallanStatusFilterModal
        setChallanStatusFilterModalVisible={setChallanStatusFilterModalVisible}
        challanStatusFilterModalVisible={challanStatusFilterModalVisible}
        sendDataToChallanList={receiveDataFromStatusFilterModal}
        upDateSelectedStatus={upDateSelectedStatus}
        OrderStatus={warehouseList}
      />
      <WarehouseStatusFilterModal
        setStatusFilterModalVisible={setChallanStatusSelectionModalVisible}
        statusFilterModalVisible={challanStatusSelectionModalVisible}
        sendDataToOrdersPageFromFilter={
          receiveDataFromStatusSelectionFilterModal
        }
        upDateSelectedStatus={upDateSelectedStatus}
        OrderStatus={["RECEIVED", "REQUESTED", "PROCESSED"]}
      />

      <ChallanDeleteModal
              setDeleteChallanModal={setDeleteChallanModal}
              deleteChallanModal={deleteChallanModal}
              sendDataToChallanListData={sendDataToChallanListData}
              challanId={selectedChallanId}
            />
      <ButtonLink />
    </div>
  );
};

export default AdminChallanList;
